import * as React from 'react';
import { MarginContainer } from '../../lib/shared';
import { icons } from '../../style/icons';
import {
  GetInvolvedHeader,
  GetInvolvedHeaderContainer,
  RedMicImage,
  GetInvolvedContainer,
  GetInvolvedHorizontalRedLines,
} from './GetInvolvedHeaderSection.style';

const GetInvolvedHeaderSection = ({ title }) => {
  const title1 = title.text.split(' ')[0];
  const title2 = title.text.split(' ')[1];
  return (
    <>
      <GetInvolvedHorizontalRedLines
        src={icons.HORIZONTAL_RED_LINES.image}
        altText={icons.HORIZONTAL_RED_LINES.altText}
      />
      <GetInvolvedContainer>
        <RedMicImage
          src={icons.PINKRED_MIC_WITH_SPARK.image}
          alt={icons.PINKRED_MIC_WITH_SPARK.altText}
        />
        <MarginContainer>
          <GetInvolvedHeaderContainer>
            <GetInvolvedHeader>{title1}</GetInvolvedHeader>
            <GetInvolvedHeader>{title2}</GetInvolvedHeader>
          </GetInvolvedHeaderContainer>
        </MarginContainer>
      </GetInvolvedContainer>
    </>
  );
};

export default GetInvolvedHeaderSection;
